import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@sla-ng/core';

import { Observable } from 'rxjs';
import { ICostTypeGroup } from '../../../../models/cost-type-group.model';
import { ICostTypeState } from '../../../../services/facades/master-data/cost-type-state.model';
import { CostTypeFacade } from '../../../../services/facades/master-data/cost-type.facade';

@Component({
    templateUrl: './cost-type-group-dialog.component.html',
    styleUrls: [ './cost-type-group-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostTypeGroupDialogComponent implements OnInit, AfterViewInit {
    public costTypeState$: Observable<ICostTypeState>;
    public formGroup: FormGroup;
    public dialogFieldsValid: boolean = false;

    constructor(
        private myMatDialogRef: MatDialogRef<CostTypeGroupDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ICostTypeGroup,
        private myCostTypeFacade: CostTypeFacade,
    ) {
    }

    public ngOnInit(): void {
        this.costTypeState$ = this.myCostTypeFacade.subState();
    }

    public ngAfterViewInit(): void {
        this.formGroup.valueChanges.subscribe((costCenterGroup: ICostTypeGroup) => {
            this.validateDialogFields(costCenterGroup);
        });
    }

    public async save(): Promise<void> {
        const data = this.formGroup.value as ICostTypeGroup;
        if (isNullOrUndefined(this.data.id)) {
            await this.myCostTypeFacade.addCostTypeGroup(data);
        } else {
            data.id = this.data.id;
            await this.myCostTypeFacade.editCostTypeGroup(data);
        }
        this.myMatDialogRef.close(true);

    }

    public close(): void {
        this.myMatDialogRef.close(false);
    }

    private validateDialogFields(costCenterGroup: ICostTypeGroup): void {
        // Validations to disable saving/editing
        if (isNullOrUndefined(costCenterGroup.name) || costCenterGroup.name.trim().length < 1) {
            this.dialogFieldsValid = false;
        } else {
            this.dialogFieldsValid = true;
        }
    }
}
